import { toConsumableArray as _toConsumableArray, objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes from 'prop-types';
import { StyledTable, TableBody, TableHead, TableFoot, TableRow, TableDataCell } from './Table.styles.js';
import TableHeaderCell from './TableHeaderCell.js';

var addOffset = function addOffset(columns, currentColumn, index) {
  var _ref = columns[index - 1] || {
      leftOffset: 0,
      width: 0
    },
    width = _ref.width,
    leftOffset = _ref.leftOffset;
  return [].concat(_toConsumableArray(columns), [_objectSpread2(_objectSpread2({}, currentColumn), {}, {
    leftOffset: width + leftOffset
  })]);
};
var Table = function Table(_ref2) {
  var _ref2$stickyColumns = _ref2.stickyColumns,
    stickyColumns = _ref2$stickyColumns === void 0 ? [] : _ref2$stickyColumns,
    _ref2$isHeadSticky = _ref2.isHeadSticky,
    isHeadSticky = _ref2$isHeadSticky === void 0 ? false : _ref2$isHeadSticky,
    _ref2$isFootSticky = _ref2.isFootSticky,
    isFootSticky = _ref2$isFootSticky === void 0 ? false : _ref2$isFootSticky,
    _ref2$selectedRows = _ref2.selectedRows,
    selectedRows = _ref2$selectedRows === void 0 ? [] : _ref2$selectedRows,
    _ref2$highlightedColu = _ref2.highlightedColumn,
    highlightedColumn = _ref2$highlightedColu === void 0 ? 0 : _ref2$highlightedColu,
    children = _ref2.children,
    _ref2$withBorder = _ref2.withBorder,
    withBorder = _ref2$withBorder === void 0 ? true : _ref2$withBorder,
    _ref2$testId = _ref2.testId,
    testId = _ref2$testId === void 0 ? undefined : _ref2$testId;
  var columns = Array.isArray(stickyColumns) ? stickyColumns : [{
    index: stickyColumns,
    width: 0
  }];
  return React__default.createElement(StyledTable, {
    $selectedRows: selectedRows,
    $stickyColumns: columns.reduce(addOffset, []),
    $isHeadSticky: isHeadSticky,
    $isFootSticky: isFootSticky,
    $highlightedColumn: highlightedColumn,
    $withBorder: withBorder,
    "data-testid": testId
  }, children);
};
Table.propTypes = {
  children: PropTypes.node.isRequired,
  highlightedColumn: PropTypes.number,
  isFootSticky: PropTypes.bool,
  isHeadSticky: PropTypes.bool,
  selectedRows: PropTypes.arrayOf(PropTypes.number),
  stickyColumns: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({
    index: PropTypes.number,
    width: PropTypes.number
  })), PropTypes.number]),
  testId: PropTypes.string,
  withBorder: PropTypes.bool
};
Table.Body = TableBody;
Table.Head = TableHead;
Table.Foot = TableFoot;
Table.Row = TableRow;
Table.HeaderCell = TableHeaderCell;
Table.DataCell = TableDataCell;

export { Table, addOffset };
//# sourceMappingURL=Table.js.map
